<script setup lang="ts">
// Overrides @basecom-gmbh/pond/components/Layout/LayoutLogo.vue
// IDS-124: add url to ids.online
withDefaults(
    defineProps<{
        smallLogo?: boolean;
        logoClasses?: string;
        withLink?: boolean;
        showWhiteLogo?: boolean;
    }>(),
    {
        smallLogo: false,
        logoClasses: '',
        withLink: true,
        showWhiteLogo: true,
    },
);

const configStore = useConfigStore();
const shopName = configStore.get('core.basicInformation.shopName') ?? 'pond';
</script>

<template>
    <NuxtLink
        :aria-label="shopName"
        :title="shopName"
        to="https://ids.online/"
    >
        <span class="sr-only">{{ shopName }}</span>
        <!-- IDS-124 - add option for black and white logo  -->
        <img
            v-if="!smallLogo"
            :alt="shopName"
            :class="logoClasses"
            :src="showWhiteLogo ? '/logo-white.svg' : '/logo-black.svg'"
        />

        <img
            v-else
            src="/logo-small.svg"
            :alt="shopName"
            :class="logoClasses"
        />
    </NuxtLink>
</template>
